/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { DatePicker, Button, Upload, Icon, Input, message } from 'antd'
import moment from 'moment'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

import { DatePickerContext, SpinContext, ErrorContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  ExportComponent,
} from 'core'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow, Title, FullHeightSizer, Content } from 'core/screen-util'
import { getBreakerData, getAuthorization, getCredentials } from 'api/pgads.js'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const gridHeader = [
  strCol({
    ident: 'transactionDate',
    display: 'Trans Date',
    width: 100,
    isFiltered: true,
  }),
  strCol({
    ident: 'transTime',
    display: 'Trans Time',
    width: 60,
    isFiltered: true,
  }),
  strCol({
    ident: 'unitName',
    display: 'Unit Name',
    width: 150,
    isFiltered: true,
  }),
  strCol({
    ident: 'displayStatus',
    display: 'Status',
    width: 180,
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const BreakerImport = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const [breakerImportData, setBreakerImportData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const [showMessages, setShowMessages] = useState(false)
  const [messages, setMessages] = useState([])
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const fetchBreakerImportData = () => {
    setSpinning(true)
    getBreakerData(apiTargetInfo)({
      date: moment(selectedDate).format('YYYY-MM-DD'),
    }).fork(setError, data => {
      setSpinning(false)
      setBreakerImportData(data)
    })
  }

  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/interface-data/import`,
    method: 'POST',
    data: { importType: 'BREAKER' },
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const { authGodMode } = envConfig
  const GridData = useRef()
  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          css={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Breaker Import
        </Title>

        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />

        <Button
          loading={spinning}
          onClick={fetchBreakerImportData}
          css={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>

        <div style={{ marginLeft: '50px' }} />
        <Upload
          {...fileProps}
          beforeUpload={_ => setSpinning(true)}
          onChange={data => {
            if (data.file.status === 'done') {
              setSpinning(false)
            }
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setShowMessages(true)
              setMessages(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.BREAKER_IMPORT_ADMIN],
                matchAny: true,
              })
            }
          >
            <Icon type="upload" /> Import
          </Button>
        </Upload>

        <div css={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{ marginRight: '20px', flex: '0 0 200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          disabled={breakerImportData.length === 0}
          getData={_ =>
            exportDataComponent(GridData, breakerImportData || [], fuzzyFilter)
          }
          headers={gridHeader}
          data={breakerImportData}
          fileName={`Breaker Import-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridData}
              data={breakerImportData}
              headers={gridHeader}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 50,
                width: width - 150,
                headerRowHeight: 30,
              })}
              fuzzyFilter={fuzzyFilter}
            />
          </Content>
        )}
      </FullHeightSizer>
      {showMessages && (
        <JcTmpErrorDialog
          errors={messages}
          visible={showMessages}
          closeErrorPrompt={_ => setShowMessages(false)}
          title="Error/Warning"
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(BreakerImport)
